import {ReactElement} from 'react';
import {Emitter} from 'interactors/messageBus/Emitter';

import {listenersList} from './listeners';
import {useConnect} from './connect';
import {useStartupEvents} from './startup';

export const MessagesEmitter = ({
  listeners = listenersList,
  emitter = Emitter,
}: MessagesEmitterProps): ReactElement => {
  useConnect({emitter, listeners});
  useStartupEvents();

  return null;
};
